import React, { useEffect, useState } from 'react';

function NBA() {
  const [partidos, setPartidos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('http://localhost:5000/api/live/nba')  // Ajusta esto si tu backend tiene otro puerto
      .then(res => res.json())
      .then(data => {
        setPartidos(data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error al cargar partidos en vivo NBA:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="p-4 text-white">
      <h2 className="text-2xl font-bold mb-4 text-blue-400">Partidos NBA en Vivo</h2>
      {loading ? (
        <p>Cargando partidos...</p>
      ) : partidos.length === 0 ? (
        <p>No hay partidos en vivo de NBA ahora mismo.</p>
      ) : (
        <ul className="space-y-2">
          {partidos.map((p, i) => (
            <li key={i} className="bg-gray-800 p-4 rounded shadow">
              <strong>{p.equipo_visitante}</strong> vs <strong>{p.equipo_local}</strong> — <span className="text-green-400">{p.hora}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default NBA;
